module.exports = __webpack_public_path__ + "img/1f681.7114f71.svg";